import request from "@/service";

/* 验证码 */
export function register() {
  return request({
    url: `/auth/oauth/register?t=` + new Date().getTime(),
    method: "get"
  });
}
